import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import LoadingPage from '@/common/pages/LoadingPage';
import { getPoliceReportQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getPoliceReport/getPoliceReportQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="گزارش پلیس" header="titleHeader">
      <ShowPoliceReport />
    </MainLayout>
  );
};
const ShowPoliceReport = () => {
  const { id } = useParams();

  const { isPending: policeReportLoading, data } = useQuery(
    getPoliceReportQueryOptions({
      id: id!,
    }),
  );

  if (policeReportLoading) {
    return <LoadingPage />;
  }
  return (
    <Box pt="1.5rem">
      <ShowIncidentParticipantsDataCard
        data={[
          {
            label: 'نوع گزارش',
            value: data?.police_report_type?.fa_const ?? '',
          },
          {
            label: 'شماره سریال کروکی',
            value: data?.police_croquis_serial_number ?? '',
          },
          {
            label: 'شماره سری کروکی',
            value: data?.police_croquis_serie_number ?? '',
          },
          { label: 'نام افسر', value: data?.police_name ?? '' },
          { label: 'کد کارشناسی', value: data?.police_report_code ?? '' },
          { label: 'شرح گزارش', value: data?.police_report_body ?? '' },
        ]}
        title=""
      />
    </Box>
  );
};
